import {useFormContext} from '@yandex-delivery/form'
import type {Optional} from '@yandex-delivery/types'
import {useCallback, useEffect, useRef} from 'react'

import {appConfig} from 'src/shared/config'
import {useBlocksVisibilityStatesContext} from 'src/shared/contexts'
import type {PointAddress as TPointAddress} from 'src/shared/types'

import type {Props} from './types'

export function usePointAddress({customLocation, name, pointType, 'data-testid': dataTestId}: Props) {
  const hasBeenManuallyToggled = useRef(false)
  const {getIsVisible, setVisible, setInvisible} = useBlocksVisibilityStatesContext()
  const {watch} = useFormContext()

  const address: Optional<TPointAddress> = watch(name)
  const isDetailsVisible = getIsVisible(name)

  const pointLocation = customLocation || appConfig.location

  const toggleDetailsVisibility = useCallback(() => {
    isDetailsVisible ? setInvisible(name) : setVisible(name)

    hasBeenManuallyToggled.current = true
  }, [name, isDetailsVisible, setInvisible, setVisible])

  useEffect(() => {
    if (hasBeenManuallyToggled.current) return

    // Если адрес пришел и блок деталей не был открыт ранее
    if (address?.fullName && !isDetailsVisible) {
      setVisible(name)
    }
  }, [name, address, isDetailsVisible, setVisible])

  return {
    isDetailsVisible,
    toggleDetailsVisibility,
    pointLocation,
    pointType,
    name,
    dataTestId,
    names: {
      _comment: `${name}._comment`,
      porch: `${name}.porch`,
      doorCode: `${name}.doorCode`,
      floor: `${name}.floor`,
      flat: `${name}.flat`,
      comment: `${name}.comment`,
      location: `${name}.coordinates`,
      log: `${name}.log`,
      shortName: `${name}.shortName`,
      fullName: `${name}.fullName`,
    },
  } as const
}
